import requset from '../request';

/**
 * 课堂分页
 */
export function classPage(obj){
    return requset({
        url:'/zs/farmingCourse/queryFarmingCoursePage',
        method:'get',
        params:obj
    })
}
/**
 * 课堂详情
 */
export function classDateil(obj){
    return requset({
        url:'/zs/farmingCourse/queryFarmingCourseInfo',
        method:'get',
        params:obj
    })
}
/**
 * 下一个课堂详情
 */
export function DateilNext(obj){
    return requset({
        url:'/zs/farmingCourse/queryNextFarmingCourseInfo',
        method:'get',
        params:obj
    })
}


// WEBPACK FOOTER //
// ./src/api/http/classroom.js